module.exports = __webpack_public_path__ + "media/images/rectangle-32@1x-699b9ffab1d12f9bff308c7c6276bc79.png";